import { Box, Divider, Tab, Tabs } from "@mui/material";
import TabPanel from "components/TabPanel";
import DetectionSandbox from "./DetectionSandbox";
import { selectCurrentField, selectToolTab, setToolTab } from "../../redux/slices/lensEditor";
import DiffSummary from "./DiffSummary";
import RulesEditor from "./RulesEditor";
import ConceptBrowser from "./ConceptBrowser";
import SelectedRules from "./SelectedRules";
import theme from "theme";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { useState } from "react";
import { BlockEntity } from "Backend";
import LensEditorHeader from "./LensEditorHeader";

function LensRules() {
  const currentField = useAppSelector(selectCurrentField);
  const toolTab = useAppSelector(selectToolTab);
  const [detectionResult, setDetectionResult] = useState<BlockEntity[]>([]);

  const dispatch = useAppDispatch();
  return (
    <Box sx={{ display: "flex", flexDirection: "column", px: 1 }}>
      <LensEditorHeader />
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          p: 2,
          flex: 1,
          gap: 2,
          height: "100%",
        }}>
        <Box
          sx={{
            overflowY: "auto",
            width: "50%",
          }}>
          <RulesEditor field={currentField} />
        </Box>
        <Divider orientation="vertical" />
        <Box
          sx={{
            px: 2,
            flex: 1,
            borderRadius: 1,
            backgroundColor: theme.palette.grey[50],
            display: "flex",
            flexDirection: "column",
          }}>
          <Tabs value={toolTab} onChange={(_evt, v) => dispatch(setToolTab({ toolTab: v }))}>
            <Tab sx={{ fontSize: "0.7rem" }} value="selection" label="Selected Rules" />
            <Tab sx={{ fontSize: "0.7rem" }} value="diff" label="Draft Summary" />
            <Tab sx={{ fontSize: "0.7rem" }} value="detection" label="Detection" />
            <Tab sx={{ fontSize: "0.7rem" }} value="search" label="Concept Browser" />
          </Tabs>
          <TabPanel index="detection" value={toolTab} overflow="auto">
            <DetectionSandbox detectionResult={detectionResult} setDetectionResult={setDetectionResult} />
          </TabPanel>
          <TabPanel index="search" value={toolTab} overflow="auto">
            <ConceptBrowser />
          </TabPanel>
          <TabPanel index="diff" value={toolTab} overflow="auto">
            <DiffSummary />
          </TabPanel>
          <TabPanel index="selection" value={toolTab} overflow="auto">
            <SelectedRules />
          </TabPanel>
        </Box>
      </Box>
    </Box>
  );
}

export default LensRules;
